/********************************************************************************

	SYNCER 縲� 遏･隴倥∵─蜍輔ｒ縺ｿ繧薙↑縺ｨ蜷梧悄(Sync)縺吶ｋ繝悶Ο繧ｰ

	* 驟榊ｸ��ｴ謇
	https://syncer.jp/jquery-modal-window

	* 譛邨よ峩譁ｰ譌･譎�
	2015/08/17 15:55

	* 菴懆�
	縺ゅｉ繧�

	** 騾｣邨｡蜈�
	Twitter: https://twitter.com/arayutw
	Facebook: https://www.facebook.com/arayutw
	Google+: https://plus.google.com/114918692417332410369/
	E-mail: info@syncer.jp

	窶ｻ 繝舌げ縲∽ｸ榊�蜷医�蝣ｱ蜻翫∵署譯医√＃隕∵悍縺ｪ縺ｩ縲√♀蠕�■縺励※縺翫ｊ縺ｾ縺吶�
	窶ｻ 逕ｳ縺苓ｨｳ縺ゅｊ縺ｾ縺帙ｓ縺後√＃蛻ｩ逕ｨ閠�ｧ倥∝九��迺ｰ蠅�↓縺翫￠繧句撫鬘後�繧ｵ繝昴�繝医＠縺ｦ縺�∪縺帙ｓ縲�

********************************************************************************/


$(function(){

//繧ｰ繝ｭ繝ｼ繝舌Ν螟画焚
var nowModalSyncer = null ;		//迴ｾ蝨ｨ髢九°繧後※縺�ｋ繝｢繝ｼ繝繝ｫ繧ｳ繝ｳ繝�Φ繝�
var modalClassSyncer = "modal-syncer" ;		//繝｢繝ｼ繝繝ｫ繧帝幕縺上Μ繝ｳ繧ｯ縺ｫ莉倥￠繧九け繝ｩ繧ｹ蜷�

//繝｢繝ｼ繝繝ｫ縺ｮ繝ｪ繝ｳ繧ｯ繧貞叙蠕励☆繧�
var modals = document.getElementsByClassName( modalClassSyncer ) ;

//繝｢繝ｼ繝繝ｫ繧ｦ繧｣繝ｳ繝峨え繧貞�迴ｾ縺輔○繧九け繝ｪ繝�け繧､繝吶Φ繝�
for(var i=0,l=modals.length; l>i; i++){

	//蜈ｨ縺ｦ縺ｮ繝ｪ繝ｳ繧ｯ縺ｫ繧ｿ繝�メ繧､繝吶Φ繝医ｒ險ｭ螳壹☆繧�
	modals[i].onclick = function(){

		//繝懊ち繝ｳ縺九ｉ繝輔か繝ｼ繧ｫ繧ｹ繧貞､悶☆
		this.blur() ;

		//繧ｿ繝ｼ繧ｲ繝�ヨ縺ｨ縺ｪ繧九さ繝ｳ繝�Φ繝�ｒ遒ｺ隱�
		var target = this.getAttribute( "data-target" ) ;

		//繧ｿ繝ｼ繧ｲ繝�ヨ縺悟ｭ伜惠縺励↑縺代ｌ縺ｰ邨ゆｺ�
		if( typeof( target )=="undefined" || !target || target==null ){
			return false ;
		}

		//繧ｳ繝ｳ繝�Φ繝�→縺ｪ繧玖ｦ∫ｴ�繧貞叙蠕�
		nowModalSyncer = document.getElementById( target ) ;

		//繧ｿ繝ｼ繧ｲ繝�ヨ縺悟ｭ伜惠縺励↑縺代ｌ縺ｰ邨ゆｺ�
		if( nowModalSyncer == null ){
			return false ;
		}

		//繧ｭ繝ｼ繝懊�繝画桃菴懊↑縺ｩ縺ｫ繧医ｊ縲√が繝ｼ繝舌�繝ｬ繧､縺悟､夐㍾襍ｷ蜍輔☆繧九�繧帝亟豁｢縺吶ｋ
		if( $( "#modal-overlay" )[0] ) return false ;		//譁ｰ縺励￥繝｢繝ｼ繝繝ｫ繧ｦ繧｣繝ｳ繝峨え繧定ｵｷ蜍輔＠縺ｪ縺�
		//if($("#modal-overlay")[0]) $("#modal-overlay").remove() ;		//迴ｾ蝨ｨ縺ｮ繝｢繝ｼ繝繝ｫ繧ｦ繧｣繝ｳ繝峨え繧貞炎髯､縺励※譁ｰ縺励￥襍ｷ蜍輔☆繧�

		//繧ｪ繝ｼ繝舌�繝ｬ繧､繧貞�迴ｾ縺輔○繧�
		$( "body" ).append( '<div id="modal-overlay"></div>' ) ;
		$( "#modal-overlay" ).fadeIn( "fast" ) ;

		//繧ｳ繝ｳ繝�Φ繝�ｒ繧ｻ繝ｳ繧ｿ繝ｪ繝ｳ繧ｰ縺吶ｋ
		centeringModalSyncer() ;

		//繧ｳ繝ｳ繝�Φ繝�ｒ繝輔ぉ繝ｼ繝峨う繝ｳ縺吶ｋ
		$( nowModalSyncer ).fadeIn( "slow" ) ;

		//[#modal-overlay]縲√∪縺溘�[#modal-close]繧偵け繝ｪ繝�け縺励◆繧俄ｦ
		$( "#modal-overlay,#modal-close" ).unbind().click( function() {

			//[#modal-content]縺ｨ[#modal-overlay]繧偵ヵ繧ｧ繝ｼ繝峨い繧ｦ繝医＠縺溷ｾ後↓窶ｦ
			$( "#" + target + ",#modal-overlay" ).fadeOut( "fast" , function() {

				//[#modal-overlay]繧貞炎髯､縺吶ｋ
				$( '#modal-overlay' ).remove() ;

			} ) ;

			//迴ｾ蝨ｨ縺ｮ繧ｳ繝ｳ繝�Φ繝�ュ蝣ｱ繧貞炎髯､
			nowModalSyncer = null ;

		} ) ;

	}

}

	//繝ｪ繧ｵ繧､繧ｺ縺輔ｌ縺溘ｉ縲√そ繝ｳ繧ｿ繝ｪ繝ｳ繧ｰ繧偵☆繧矩未謨ｰ[centeringModalSyncer()]繧貞ｮ溯｡後☆繧�
	$( window ).resize( centeringModalSyncer ) ;

	//繧ｻ繝ｳ繧ｿ繝ｪ繝ｳ繧ｰ繧貞ｮ溯｡後☆繧矩未謨ｰ
	function centeringModalSyncer() {

		//繝｢繝ｼ繝繝ｫ繧ｦ繧｣繝ｳ繝峨え縺碁幕縺�※縺ｪ縺代ｌ縺ｰ邨ゆｺ�
		if( nowModalSyncer == null ) return false ;

		//逕ｻ髱｢(繧ｦ繧｣繝ｳ繝峨え)縺ｮ蟷��ｫ倥＆繧貞叙蠕�
		var w = $( window ).width() ;
		var h = $( window ).height() ;

		//繧ｳ繝ｳ繝�Φ繝�(#modal-content)縺ｮ蟷��ｫ倥＆繧貞叙蠕�
		// jQuery縺ｮ繝舌�繧ｸ繝ｧ繝ｳ縺ｫ繧医▲縺ｦ縺ｯ縲∝ｼ墓焚[{margin:true}]繧呈欠螳壹＠縺滓凾縲∽ｸ榊�蜷医ｒ襍ｷ縺薙＠縺ｾ縺吶�
//		var cw = $( nowModalSyncer ).outerWidth( {margin:true} ) ;
//		var ch = $( nowModalSyncer ).outerHeight( {margin:true} ) ;
		var cw = $( nowModalSyncer ).outerWidth() ;
		var ch = $( nowModalSyncer ).outerHeight() ;

		//繧ｻ繝ｳ繧ｿ繝ｪ繝ｳ繧ｰ繧貞ｮ溯｡後☆繧�
		$( nowModalSyncer ).css( {"left": ((w - cw)/2) + "px","top": ((h - ch)/2) + "px"} ) ;

	}

} ) ;